export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-button/index.js